import dayjs from "dayjs";

export const PrimaryOrderConfig = {
  columns: [
    { headerName: "Order Reference No.", mappedValue: "orderNumber", width: 170, headerAlign: "left", align: "left" },
    {
      headerName: "Order Date & Time",
      mappedValue: "creationTime",
      width: 170,
      headerAlign: "left",
      align: "left",
      renderCell: (params: any) => dayjs(params.value).format("DD-MM-YYYY HH:mm:ss"), 
    },
    { headerName: "Quantity", mappedValue: "totalCaseQuantity, totalPieceQuantity, totalOtherUnitQuantity", width: 120, headerAlign: "left", align: "left", 
      type: "viewprimaryorderconfigs", },
    { headerName: "Amount", mappedValue: "netAmount", width: 120, headerAlign: "left", align: "left" },
    { headerName: "Order Status", mappedValue: "status", width: 170, headerAlign: "left", align: "left" },
    { headerName: "GRN Status(if any)", mappedValue: " ", width: 170, headerAlign: "left", align: "left" },
  ],
  Actions: ["view", "download"],
};
